import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { EthiopianCross } from "@/components/EthiopianCross";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("raffle_admin_token")) {
      api.get("/auth/me").then(() => nav("/admin")).catch(() => localStorage.removeItem("raffle_admin_token"));
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("raffle_admin_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8" data-testid="admin-login-back"><ArrowLeft className="w-4 h-4" /> Back to site</Link>
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <EthiopianCross className="w-20 h-20 mx-auto" />
            <h1 className="font-heading text-3xl font-bold mt-3">Admin Portal</h1>
            <p className="text-[#4A4A4A] text-sm mt-1">Raffle Management Dashboard</p>
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label className="mb-1 block">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter admin email" data-testid="admin-email" />
            </div>
            <div>
              <Label className="mb-1 block">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password" />
            </div>
            {error && <p className="text-sm text-[#D00000]" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full bg-[#9E1B1B] hover:bg-[#7A1414] text-white py-6 font-semibold" data-testid="admin-login-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Lock className="w-4 h-4 mr-2" /> Sign In</>}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
